export default [
  {
    id: 1,
    name: 'Converted',
    label: 'Converted',
    value: 'converted',
  },
  {
    id: 2,
    name: 'Displacement',
    label: 'Displacement',
    value: 'displacement',
  },
  {
    id: 3,
    name: 'Other',
    label: 'Other',
    value: 'other',
  },
];
